import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { LookInside } from './components/LookInside';
import { Tomes } from './components/Tomes';
import { VolumeCarousel } from './components/VolumeCarousel';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { UseCases } from './components/UseCases';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { voices } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink selection:bg-ochre selection:text-ink" data-id="element-0" data-mp="3mkhm3t5g125i">
      <MetaPixel data-id="element-1" data-mp="3rdkie91luppe" />
      <main data-id="element-2" data-mp="3rd1a7k1rbfok">
        <Hero data-id="element-3" data-mp="3recbnd7qcbci" />
        <SocialProofBar data-id="element-4" data-mp="5yi8qe3h5da" />
        <PainGrid data-id="element-5" data-mp="67yhm9c7y5s" />
        <ProductReveal data-id="element-6" data-mp="4n5i12o8na1" />
        <LookInside data-id="element-7" data-mp="56qxrrj5tst" />
        <Tomes data-id="element-8" data-mp="2zl3alhpbj03q" />
        <VolumeCarousel data-id="element-9" data-mp="2zllf11m4wkmq" />
        <Bonuses data-id="element-10" data-mp="2zm4xqkjlzd1t" />
        <ValueStack data-id="element-11" data-mp="2zmo5x9jgin2n" />
        <Urgency data-id="element-12" data-mp="2zng1ikd20ksx" />
        <Pricing data-id="element-13" data-mp="33mf2xuzktzfm" />
        <Testimonials voices={voices} background="cream" data-id="element-14" data-mp="33lwxq8uxsavk" />
        <Guarantee data-id="element-15" data-mp="33oi337ug18y2" />
        <Faq data-id="element-16" data-mp="38m1gy6n8bjph" />
        <UseCases data-id="element-17" data-mp="38l8eviz7tido" />
        <CostOfInaction data-id="element-18" data-mp="38kqgafp2ys2l" />
        <Close data-id="element-19" data-mp="38kgm0fx05yr3" />
      </main>
      <Footer data-id="element-20" data-mp="3dkuw03i5zirr" />
      <PurchaseNotifications data-id="element-21" data-mp="3dle28mygcipy" />
    </div>;
}